import { render, staticRenderFns } from "./MonitorChapter.vue?vue&type=template&id=f9baa69c&scoped=true&"
import script from "./MonitorChapter.vue?vue&type=script&lang=js&"
export * from "./MonitorChapter.vue?vue&type=script&lang=js&"
import style0 from "./MonitorChapter.vue?vue&type=style&index=0&id=f9baa69c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9baa69c",
  null
  
)

export default component.exports